module.exports = __webpack_public_path__ + "static/media/190611_DoreJaune-02.63e94439.png";